import { LOG_OUT, REQUEST_LOGIN_SUCCESS } from '../utils/constants';

const initialState = {
  token: null,
  isLoggedIn: false
};

export const adminLoginReducer = (state = initialState, action) => {  
  switch (action.type) {
    case REQUEST_LOGIN_SUCCESS:
      return {
        ...state,
        userInfo: action.payload.data,
        isLoggedIn: true
      };

    case LOG_OUT:
      return {
        user: {},
        isLoggedIn: false
      };
    default:
      return state;
  }
};
